<div class="root">
  <div class="videos" [ngStyle]="limitRowsStyle()">

    <div class="video-wrapper" *ngFor="let video of videos">
      <my-video-miniature
        [video]="video" [user]="getUser()" [displayAsRow]="false"
        [displayVideoActions]="true" [displayOptions]="displayOptions"
      >
      </my-video-miniature>
    </div>

  </div>
</div>
